import getUpsellFunnelStep from './getUpsellFunnelStep';
import setUpsellSession from './setUpsellSession';
import getSessionId from './getSessionId';
import { isRecurringPurchase } from './multiPrice';

export default function storeUpsellSession(payment, checkout, sellerId, cookies) {
  const product = checkout.product;

  // Whether this payment is a subscription or a one-time charge is driven by the
  // price the buyer actually bought, not product.type — a legacy scalar derived
  // from the first active price that can disagree with the purchase on a
  // multi-price product. isRecurringPurchase falls back to product.type for
  // legacy products with no prices[].
  const purchasedPrice = (product?.prices ?? []).find(
    p => String(p._id) === String(payment.productPriceId),
  );
  const isSubscription = isRecurringPurchase(purchasedPrice, product);
  const isCharge = !isSubscription;

  const upsellFunnelStep = getUpsellFunnelStep(checkout);

  setUpsellSession(
    {
      initialCheckoutId: checkout._id,
      initialSellerId: sellerId,
      // The upsell can land in a storage partition that has never seen this
      // session, and the API reads the initial purchase back by session.
      initialSessionId: getSessionId(),
      ...(isSubscription && { initialSubscriptionId: payment._id }),
      ...(isCharge && { initialPaymentId: payment._id }),
      customerId: payment.customer._id,
      // Display-only hint so the upsell page paints the test banner and loads the
      // test Stripe key. The API re-derives mode from the initiating record.
      livemode: payment.livemode,
      upsell: upsellFunnelStep.config, // Use .config directly
    },
    cookies,
  );
}
